import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import {
  RecognitionPlansIcon,
  BenefitsForPlansIcon,
  RecognitionAnalysisIcon,
} from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const RecognitionScreenSelector = () => {

  const data = [
    {
      name: getLocalizedString("benefitsForPlans"),
      icon: <BenefitsForPlansIcon />,
      path: paths.benefitsForPlans,
    },
    {
      name: getLocalizedString("recognitionPlans"),
      icon: <RecognitionPlansIcon />,
      path: paths.recognitionPlans,
    },
    {
      name: getLocalizedString("recognitionAnalysis"),
      icon: <RecognitionAnalysisIcon />,
      path: paths.recognitionAnalysis,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("recognitionScreenSelector")}
      data={data}
    />
  );
}

export default RecognitionScreenSelector;
